<div class="form-group" [class.has-error]="showError">
    <label *ngIf="to.label && to.hideLabel !== true" [attr.for]="id">
        {{ to.label }}
        <span *ngIf="to.required && to.hideRequiredMarker !== true">*</span>
    </label>
    <div class="inner-addon right-addon">
        <a *ngIf="hasValue" class="rmv-btn glyphicon">
            <img title="copy" (click)="searchClicked()" class="ml-1 me-2" src="design/images/Recruitment.png">
        </a>
        <ng-template #fieldComponent></ng-template>
    </div>
    <div *ngIf="showError" class="invalid-feedback" [style.display]="'block'">
        <formly-validation-message [field]="field"></formly-validation-message>
    </div>
    <small *ngIf="to.description" class="form-text text-muted">{{ to.description }}</small>
</div>